module.exports = __webpack_public_path__ + "static/img/logo.3fd6e205.png";